import { render, staticRenderFns } from "./binding.vue?vue&type=template&id=b6a0ecd0&scoped=true&"
import script from "./binding.vue?vue&type=script&lang=ts&"
export * from "./binding.vue?vue&type=script&lang=ts&"
import style0 from "./binding.vue?vue&type=style&index=0&id=b6a0ecd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a0ecd0",
  null
  
)

export default component.exports